const Images =  {
  register_first: "/images/register.png",
  register_second:"/images/register_two.png",
  register_third:"/images/register_three.png",
  register_four:"/images/register_four.png",
  register_five:"/images/register_five.png",
  register_six:"/images/register_six.png",
  register_seven:"/images/register_seven.png",
  register_eight:"/images/register_eight.png",
  register_ten:"/images/register_ten.jpg",
  banner:"/images/bannerImage.png",
  cardPic:"/images/cardPic.png",
  landing:"/images/landinghero.png",
  faqs:"/images/faqpic.png",
  logo:"/images/logo.png",

  // CAROUSEL IMAGES
  carousel_one:"/images/carousel_one.png",
  carousel_two:"/images/carousel_two.png",
  carousel_three:"/images/carousel_three.png",
  carousel_four:"/images/carousel_four.png",
  carousel_five:"/images/carousel_five.png",

  // SAMPLE COMPANY AND PRODUCT IMAGE
  company_logo:"/images/company_logo.png",
  product_img:"/images/product_img.png",

  bullet:"/images/bulletPoint.png",

  // SOCIALS
  facebook:"/images/facebook.png",
  instagram:"/images/instagram.png",
  twitter:"/images/twitter.png",

  // ADVERT IMAGES
  advert_one:"/images/advert_one.png",
  advert_five:"/images/advert_five.png",
  advert_three:"/images/advert_three.png",
  advert_four:"/images/advert_four.png",
  advert_six:"/images/advert_six.png",
  advert_seven:"/images/advert_seven.png",
  getting_started:"/images/getting_started_img.png",

  // CATEGORY IMG
  category_img:"/images/category_img.png",
  category_img_two:"/images/category_img_two.png",
  category_img_three:"/images/category_img_three.png",

  wavyBackground:"/images/background.png",

  // Electronic images
  electronic_img_one:"/images/electronics/electronic_img_one.jpg",
  electronic_img_two:"/images/electronics/electronic_img_two.jpg",
  electronic_img_three:"/images/electronics/electronic_img_three.jpg",
  gift:"/images/gift.png",

  // COMPANY LOGOS
  bolt:"/images/company_logo/bolt.png",
  compu_ghana:"/images/company_logo/compu_ghana.png",
  gino:"/images/company_logo/gino.png",
  hubtel:"/images/company_logo/hubtel.png",
  kivo:"/images/company_logo/kivo.png",
  max_mart:"/images/company_logo/max_mart.png",
  melcome:"/images/company_logo/melcome.png",
  nestle:"/images/company_logo/nestle.png",
  palace:"/images/company_logo/palace.png",
  voltic:"/images/company_logo/voltic.png",

  faq_img:"/images/faq_img.png",
  cta_img:"/images/cta_img.png",

  visa:"/images/visa.svg",
  mastercard:"/images/mastercard.svg",
  mastercard_alt:"/images/mastercard_alt.svg",

  sms_sender: "/Images/sms_sender.png",

  campaign_alt:"/images/campaign_alt.png",
  digital_campaign:"/images/digital_campaign.png",


  // CATEGORY IMAGES
  fashion:"/images/fashion.png",
  electronics:"/images/electronics.png",
  events:"/images/events.png",
  car:"/images/car.png",
  cinema:"/images/cinema.png",
  furniture:"/images/furniture.png",
  house:"/images/house.png",
  mother_and_daughter:"/images/mother-and-daughter.png",
  restaurant:"/images/restaurant.png",
  grocery:"/images/grocery.png",
  spa:"/images/spa.png",
  sports:"/images/sports.png",
  travel:"/images/travel-and-tourism.png",

  brandIcon:"/images/brandIcon.png",
  brandLogo:"/images/brands_logo.png",
  categoryLogo:"/images/category.png",
  imagePlaceholder:"/images/placeholder-image.jpg",

};

export default Images;